<form novalidate #setupForm="ngForm">
  <div class="setup-container">
    <div class="section-container">
      <div class="section-label identity">Identity</div>
      <div class="section-data">
        <nrwl-test-identity
          [testName]="testName"
          [customer]="customerName"
          [contact]="contact"
          [email]="email"
          [phone]="phone"
          [technicianId]="technicianId"
          [comments]="comments"
          [technician]="technicianName"
          [editMode]="editMode || cloneMode"
          (updateTestIdentity)="updateTestIdentity($event)"
        ></nrwl-test-identity>
      </div>
    </div>
    <div class="section-container">
      <div class="section-label">Test Type</div>
      <div class="section-data">
        <div class="group">
          <div class="label">BERT Payload</div>
          <mat-select
            name="layerToTest"
            class="option-list"
            #layerToTestInput="ngModel"
            [(ngModel)]="setupFormField.layerToTest"
            (selectionChange)="onLayerChange()"
          >
            <mat-option *ngFor="let layers of layerTypes" [value]="layers.value">{{
              layers.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group" *ngIf="setupFormField.layerToTest === 'L3'">
          <div class="label">
            IP Address Type
            <i class="mdi mdi-help-circle-outline" matTooltip="{{ formTooltip.ipAddressType }}"></i>
          </div>
          <mat-select
            name="ipAddrType"
            class="option-list"
            #ipAddrTypeInput="ngModel"
            [(ngModel)]="setupFormField.ipAddrType"
            (selectionChange)="onIpAddressTypeChange()"
          >
            <mat-option *ngFor="let ipTypes of ipAddressTypes" [value]="ipTypes.value">{{
              ipTypes.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group">
          <div class="label">BERT Pattern</div>
          <mat-select
            name="bertPattern"
            class="option-list"
            #bertPatternInput="ngModel"
            [(ngModel)]="setupFormField.bertPattern"
            (selectionChange)="onBertPatternChange()"
          >
            <mat-option *ngFor="let pattern of bertPatternTypes" [value]="pattern.value">{{
              pattern.name
            }}</mat-option>
          </mat-select>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div>
        <img class="icon" [attr.src]="'images/SPTIcon.svg'" />
        <div class="section-label">BERT Performance Test</div>
      </div>
    </div>
    <div class="section-container height-120">
      <div class="section-label"><label>Schedule</label></div>
      <div class="scheduler-section">
        <viavi-scheduler
          [scheduleValue]="scheduleInfoData"
          (schedulerDataVal)="fetchSchedulerVal($event)"
          [isDisabledScheduler]="isDisabledScheduler"
          [schedulerEnds]="schedulerEnds"
          [minDuration]="minDurationSeconds"
        >
        </viavi-scheduler>
      </div>
    </div>
  </div>
</form>
